import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContextSystem } from '@wp-g2/context';
import { useFlexItem } from './useFlexItem';
/**
 * @typedef {Omit<import('./useFlexItem').Props, 'isBlock'>} FlexBlockProps
 */

/**
 * @param {import('@wp-g2/create-styles').ViewOwnProps<FlexBlockProps, 'div'>} props
 */

export function useFlexBlock(props) {
  var otherProps = useContextSystem(props, 'FlexBlock');
  var flexItemProps = useFlexItem(_objectSpread({
    isBlock: true
  }, otherProps));
  return flexItemProps;
}